import React from 'react';
import './styles.css';

/**
 * 表單日期選擇器組件
 * 用於顯示帶有標籤的日期選擇輸入框
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.id - 日期選擇器ID
 * @param {string} props.label - 日期選擇器標籤
 * @param {string} props.value - 日期選擇器值
 * @param {Function} props.onChange - 值變更回調函數
 * @param {string} props.placeholder - 佔位符文本
 * @param {boolean} props.required - 是否必填
 * @param {string} props.error - 錯誤信息
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 表單日期選擇器組件
 */
function FormDatePicker({
    id,
    label,
    value,
    onChange,
    placeholder = '',
    required = false,
    error = '',
    className = '',
    ...rest
}) {
    return (
        <div className={`form-datepicker-container ${error ? 'has-error' : ''} ${className}`}>
            {label && (
                <label htmlFor={id} className="form-datepicker-label">
                    {label}
                    {required && <span className="form-datepicker-required">*</span>}
                </label>
            )}

            <input
                id={id}
                type="date"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="form-datepicker"
                required={required}
                {...rest}
            />

            {error && <p className="form-datepicker-error">{error}</p>}
        </div>
    );
}

export default FormDatePicker; 